import { ref } from 'vue';

// EOR magic-link POC session token. Deliberately a SEPARATE localStorage key
// from the staff `auth_token` (see useAuth.js) so the vendor-facing magic-link
// session never collides with or impersonates a staff login.
const SESSION_KEY = 'eor_session_token';

const sessionToken = ref(localStorage.getItem(SESSION_KEY));

export function useMagicLink() {
  const setSession = (token) => {
    sessionToken.value = token;
    localStorage.setItem(SESSION_KEY, token);
  };

  const clearSession = () => {
    sessionToken.value = null;
    localStorage.removeItem(SESSION_KEY);
  };

  const getSession = () => sessionToken.value;

  return { sessionToken, setSession, clearSession, getSession };
}
